import { types, flow, getEnv } from 'mobx-state-tree';
import {
  CREATE_BIX_AUTO_OFFER_UPSELL,
  GET_ADDITIONAL_OFFER_DATA,
  SET_ADDITIONAL_OFFER_DATA
} from './additional-offers.queries';

const BixAutoUpsellState = types.model({
  status: types.enumeration('BixAutoUpsellStatus', ['loading', 'success', 'hidden']),
  offerId: types.maybeNull(types.string),
  autoMonthlyPremium: types.maybeNull(types.number)
});

export const AdditionalOffersStore = types
  .model({
    webUserId: types.maybeNull(types.string),
    termLifeLastSubmitted: types.maybeNull(types.string),
    bixAutoUpsell: types.maybeNull(BixAutoUpsellState)
  })
  .actions((self) => ({
    getAdditionalOfferData: flow(function* getAdditionalOfferData(webUserId) {
      const { client } = getEnv(self);

      try {
        const { data } = yield client.query({
          query: GET_ADDITIONAL_OFFER_DATA,
          variables: {
            webUserId
          }
        });
        const {
          getAdditionalOfferData: { termLifeLastSubmitted }
        } = data;
        self.termLifeLastSubmitted = termLifeLastSubmitted;
        self.webUserId = webUserId;
      } catch {
        // error here means it is not in the table which is ok.
      }
    }),
    setAdditionalOfferData: flow(function* setAdditionalOfferData(webUserId, termLifeLastSubmitted) {
      const { client } = getEnv(self);
      try {
        const { data } = yield client.mutate({
          mutation: SET_ADDITIONAL_OFFER_DATA,
          variables: {
            additionalOfferData: {
              webUserId,
              termLifeLastSubmitted
            }
          }
        });
        const { setAdditionalOfferData } = data;
        self.termLifeLastSubmitted = setAdditionalOfferData.termLifeLastSubmitted;
        self.webUserId = webUserId;
      } catch {}
    }),
    loadBixAutoUpsell: flow(function* loadBixAutoUpsell(input) {
      if (!input?.branchOfferId && !input?.branchPolicyId) {
        return;
      }
      self.bixAutoUpsell = { status: 'loading', offerId: null, autoMonthlyPremium: null };

      const { client } = getEnv(self);
      try {
        const { data } = yield client.mutate({
          mutation: CREATE_BIX_AUTO_OFFER_UPSELL,
          variables: { input }
        });
        const payload = data?.createBixAutoOfferUpsell;
        if (payload?.__typename === 'CreateBixAutoOfferUpsellSuccess' && payload.offerId) {
          self.bixAutoUpsell = {
            status: 'success',
            offerId: payload.offerId,
            autoMonthlyPremium: payload.autoMonthlyPremium ?? null
          };
        } else {
          self.bixAutoUpsell = { status: 'hidden', offerId: null, autoMonthlyPremium: null };
        }
      } catch {
        self.bixAutoUpsell = { status: 'hidden', offerId: null, autoMonthlyPremium: null };
      }
    })
  }));
